/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lean_Safe_Jay_DartInputs */

const en_lean_safe_jay_dart = /** @type {(inputs: Lean_Safe_Jay_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments cannot be shared for this segment.`)
};

const de_lean_safe_jay_dart = /** @type {(inputs: Lean_Safe_Jay_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare können für dieses Segment nicht freigegeben werden.`)
};

/**
* | output |
* | --- |
* | "Comments cannot be shared for this segment." |
*
* @param {Lean_Safe_Jay_DartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lean_safe_jay_dart = /** @type {((inputs?: Lean_Safe_Jay_DartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lean_Safe_Jay_DartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lean_safe_jay_dart(inputs)
	return de_lean_safe_jay_dart(inputs)
});